<p-toast position="top-center" [baseZIndex]="11000"></p-toast>

<ng-container *ngIf="!isInsideModal">
	<app-breadcrumb [title]="'menu.users' | translate" [showTrail]="false"></app-breadcrumb>
</ng-container>

<ng-container *ngIf="!isInsideModal">
	<div class="container-fluid">
		<div class="row">
			<div class="col-sm-12">
				<div class="users-card">
					<!-- Card Header -->
					<div class="users-card-header">
						<div class="users-header-top">
							<span class="users-count-badge" *ngIf="usersTotalCount != null">
								<i class="fa fa-users" aria-hidden="true"></i>
								<span>{{ usersTotalCountLabel }}</span>
							</span>

							<div class="users-header-actions">
								<button class="users-btn users-btn-add" (click)="openXl(content)" *ngIf="user_type == 200">
									<i class="fa fa-plus"></i>
									<span class="users-btn-label">{{ 'users.info.addUser' | translate }}</span>
								</button>
								<button class="users-btn users-btn-add" (click)="openXl2(content2)" *ngIf="user_type == 100">
									<i class="fa fa-plus"></i>
									<span class="users-btn-label">{{ 'users.info.addUser' | translate }}</span>
								</button>
								<button class="users-btn users-btn-refresh" (click)="refreshUsersData()">
									<i class="fa fa-refresh"></i>
								</button>
							</div>
						</div>

						<!-- Segmented toggle + search row -->
						<div class="users-toolbar">
							<div class="users-scope-toggle" *ngIf="canUsePlatformUsers">
								<button class="scope-btn" [class.active]="userScope === 'all'"
									(click)="userScope = 'all'; onUserScopeChange()">
									<i class="fa fa-users"></i>
									{{ 'users.scope.myUsers' | translate }}
								</button>
								<button class="scope-btn" [class.active]="userScope === 'admin'"
									(click)="userScope = 'admin'; onUserScopeChange()">
									<i class="fa fa-globe"></i>
									{{ 'users.scope.allPlatform' | translate }}
								</button>
							</div>

							<div class="users-search">
								<i class="fa fa-search users-search-icon"></i>
								<input #globalFilterInput type="text" [(ngModel)]="globalFilterValue"
									(input)="onUsersSearch($event.target.value)"
									placeholder="{{ 'users.info.search' | translate }}"
									class="users-search-input" />
								<button *ngIf="globalFilterValue" type="button" class="users-search-clear"
									(click)="clearGlobalFilter(dt, globalFilterInput)">
									<i class="fa fa-times"></i>
								</button>
							</div>
						</div>
					</div>

					<!-- Desktop table (lg+) -->
					<div class="users-table-wrap d-none d-lg-block">
						<p-table #dt [value]="userData"
							[paginator]="true"
							[rows]="getUsersTableRows()"
							[lazy]="true"
							[totalRecords]="getUsersTableTotal()"
							[loading]="isUsersTableLoading()"
							(onLazyLoad)="onUsersTableLazyLoad($event)"
							[globalFilterFields]="['user_name', 'phone_number', 'createdByDisplayName', 'createdBy.user_name']" [responsiveLayout]="'stack'"
							[rowsPerPageOptions]="[10, 25, 50, 100]"
							[showCurrentPageReport]="true"
							[currentPageReportTemplate]="getUsersPageReport()"
							[sortMode]="'multiple'">
							<ng-template pTemplate="header">
								<tr>
									<th pSortableColumn="user_name">
										{{ 'users.table.userName' | translate }}
										<p-sortIcon field="user_name"></p-sortIcon>
									</th>
									<th>
										{{ 'users.table.phoneNumber' | translate }}
									</th>
									<th pSortableColumn="user_type">
										{{ 'users.table.userType' | translate }}
										<p-sortIcon field="user_type"></p-sortIcon>
									</th>
									<th pSortableColumn="verified" style="width: 90px; text-align: center;">
										{{ 'users.table.verified' | translate }}
										<p-sortIcon field="verified"></p-sortIcon>
									</th>
									<th pSortableColumn="user_status" style="width: 90px; text-align: center;">
										{{ 'users.table.status' | translate }}
										<p-sortIcon field="user_status"></p-sortIcon>
									</th>
									<th pSortableColumn="createdDate">
										{{ 'users.table.createdDate' | translate }}
										<p-sortIcon field="createdDate"></p-sortIcon>
									</th>
									<th>{{ 'users.table.createdBy' | translate }}</th>
									<th style="text-align: center;">
										{{ 'users.table.privileges' | translate }}
									</th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-item>
								<tr>
									<td>
										<div class="user-name-cell">
											<span class="user-avatar-sm">{{ item?.user_name?.charAt(0)?.toUpperCase() || '?' }}</span>
											<span class="user-name-text">{{ item?.user_name }}</span>
										</div>
									</td>
									<td>
										<span class="user-phone">{{ formatPhoneNumber(item?.phone_number) }}</span>
									</td>
									<td>
										<span class="user-type-chip">{{ getUserTypeLabel(item) }}</span>
									</td>
									<td style="text-align: center;">
										<i *ngIf="item?.mverified == 1" class="fa fa-check-circle" style="font-size: 18px; color: #22c55e;"></i>
										<i *ngIf="item?.mverified == 0" class="fa fa-times-circle" style="font-size: 18px; color: #ef4444;"></i>
									</td>
									<td style="text-align: center;">
										<button [disabled]="item.user_type === 200 || item.user_type === 100"
											*ngIf="item.user_status == 1" class="btn p-0 border-0"
											(click)="changeUserStatus(item?.user_id, item.user_status)">
											<i class="fa fa-toggle-on" style="color: #3b82f6; font-size: 22px;"></i>
										</button>
										<button *ngIf="item.user_status == 59" class="btn p-0 border-0"
											(click)="changeUserStatus(item?.user_id, item.user_status)">
											<i class="fa fa-toggle-off" style="color: #94a3b8; font-size: 22px;"></i>
										</button>
									</td>
									<td>
										<span class="user-date">{{ item.createdDate | date: 'dd/MM/yyyy' }}</span>
									</td>
									<td>
										<span class="small creator-label" [class.creator-label--fallback]="isCreatedByFallback(item)">
											{{ getCreatedByLabel(item) }}
										</span>
									</td>
									<td style="text-align: center;">
										<div class="user-actions-group">
											<ng-container *ngIf="canShowPrivileges(item)">
												<i routerLink="/dashboard/user-privileges/{{item?.user_id}}"
													class="fa fa-shield user-privilege-icon"
													[title]="'users.table.privileges' | translate"></i>
											</ng-container>
											<i *ngIf="canShowLockIcon(item)" class="fa fa-lock user-lock-icon"></i>

											<ng-container *ngIf="canUseSecurityCode">
												<button class="sc-action-btn sc-view" (click)="viewSecurityCode(item.user_id)"
													[title]="curentLang === 'ar' ? 'عرض كود الأمان' : curentLang === 'he' ? 'הצג קוד אבטחה' : 'View Security Code'">
													<i class="fa fa-eye"></i>
												</button>
												<button class="sc-action-btn sc-send" (click)="sendSecurityCodeSms(item.user_id)"
													[title]="curentLang === 'ar' ? 'إرسال كود الأمان SMS' : curentLang === 'he' ? 'שלח קוד אבטחה ב-SMS' : 'Send Code via SMS'">
													<i class="fa fa-paper-plane"></i>
												</button>
												<button class="sc-action-btn sc-change" (click)="rotateSecurityCode(item.user_id)"
													[title]="curentLang === 'ar' ? 'تغيير كود الأمان' : curentLang === 'he' ? 'שנה קוד אבטחה' : 'Change Security Code'">
													<i class="fa fa-refresh"></i>
												</button>
											</ng-container>
										</div>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="8" class="text-center" style="padding: 40px 0; color: #94a3b8;">
										<i class="fa fa-inbox" style="font-size: 28px; display: block; margin-bottom: 8px;"></i>
										{{ 'users.info.noData' | translate }}
									</td>
								</tr>
							</ng-template>
						</p-table>
					</div>

					<!-- Mobile & tablet cards (< lg) -->
					<div class="crud-cards-list d-lg-none">
						<div class="crud-card" *ngFor="let item of getFilteredUsersForCards(); let i = index">
							<div class="cc-header">
								<div class="cc-avatar">
									<span>{{ item?.user_name?.charAt(0)?.toUpperCase() || '?' }}</span>
								</div>
								<div class="cc-title-block">
									<div class="cc-name">{{ item?.user_name }}</div>
									<div class="cc-sub">{{ formatPhoneNumber(item?.phone_number) }}</div>
								</div>
								<span class="cc-badge" [style.background]="item.user_status == 1 ? '#dcfce7' : '#f1f5f9'" [style.color]="item.user_status == 1 ? '#16a34a' : '#64748b'">
									{{ item.user_status == 1 ? ('users.table.statusActive' | translate) : ('users.table.statusInactive' | translate) }}
								</span>
							</div>
							<div class="cc-body">
								<div class="cc-info-row">
									<span class="cc-label">{{ 'users.table.userType' | translate }}</span>
									<span class="cc-value">{{ getUserTypeLabel(item) }}</span>
								</div>
								<div class="cc-info-row">
									<span class="cc-label">{{ 'users.table.verified' | translate }}</span>
									<span class="cc-value">
										<i *ngIf="item?.mverified == 1" class="fa fa-check-circle" style="color: #22c55e;"></i>
										<i *ngIf="item?.mverified == 0" class="fa fa-times-circle" style="color: #ef4444;"></i>
									</span>
								</div>
								<div class="cc-info-row">
									<span class="cc-label">{{ 'users.table.createdDate' | translate }}</span>
									<span class="cc-value">{{ item.createdDate | date: 'dd/MM/yyyy' }}</span>
								</div>
								<div class="cc-info-row">
									<span class="cc-label">{{ 'users.table.createdBy' | translate }}</span>
									<span class="cc-value creator-label" [class.creator-label--fallback]="isCreatedByFallback(item)">
										{{ getCreatedByLabel(item) }}
									</span>
								</div>
								<div class="cc-info-row">
									<span class="cc-label">{{ 'users.table.status' | translate }}</span>
									<button [disabled]="item.user_type === 200 || item.user_type === 100" *ngIf="item.user_status == 1" class="btn p-0 border-0" (click)="changeUserStatus(item?.user_id, item.user_status)">
										<i class="fa fa-toggle-on" style="color: #3b82f6; font-size: 20px;"></i>
									</button>
									<button *ngIf="item.user_status == 59" class="btn p-0 border-0" (click)="changeUserStatus(item?.user_id, item.user_status)">
										<i class="fa fa-toggle-off" style="color: #94a3b8; font-size: 20px;"></i>
									</button>
								</div>
							</div>
							<div class="cc-actions">
								<ng-container *ngIf="canShowPrivileges(item)">
									<a [routerLink]="['/dashboard/user-privileges/', item?.user_id]" class="cc-action-btn" [title]="'users.table.privileges' | translate">
										<i class="fa fa-shield"></i>
									</a>
								</ng-container>
								<ng-container *ngIf="canUseSecurityCode">
									<button class="sc-action-btn sc-view" (click)="viewSecurityCode(item.user_id)"
										[title]="curentLang === 'ar' ? 'عرض كود الأمان' : curentLang === 'he' ? 'הצג קוד אבטחה' : 'View Security Code'">
										<i class="fa fa-eye"></i>
									</button>
									<button class="sc-action-btn sc-send" (click)="sendSecurityCodeSms(item.user_id)"
										[title]="curentLang === 'ar' ? 'إرسال كود الأمان SMS' : curentLang === 'he' ? 'שלח קוד אבטחה ב-SMS' : 'Send Code via SMS'">
										<i class="fa fa-paper-plane"></i>
									</button>
									<button class="sc-action-btn sc-change" (click)="rotateSecurityCode(item.user_id)"
										[title]="curentLang === 'ar' ? 'تغيير كود الأمان' : curentLang === 'he' ? 'שנה קוד אבטחה' : 'Change Security Code'">
										<i class="fa fa-refresh"></i>
									</button>
								</ng-container>
							</div>
						</div>
						<p *ngIf="getFilteredUsersForCards().length === 0 && !isUsersTableLoading()" class="text-center text-muted py-3">{{ 'users.info.noData' | translate }}</p>
					</div>

					<div class="users-mobile-pagination d-lg-none" *ngIf="getUsersTableTotal() > 0">
						<button type="button" class="users-mobile-page-btn"
							[disabled]="(isPlatformUsersMode() ? platformPage : myUsersPage) <= 1 || isUsersTableLoading()"
							(click)="isPlatformUsersMode() ? onPlatformPageChange(platformPage - 1) : onMyUsersPageChange(myUsersPage - 1)">
							<i class="fa fa-chevron-left"></i>
						</button>
						<span class="users-mobile-page-report">{{ getUsersPageReport() }}</span>
						<button type="button" class="users-mobile-page-btn"
							[disabled]="(isPlatformUsersMode() ? platformPage * platformRows : myUsersPage * myUsersRows) >= getUsersTableTotal() || isUsersTableLoading()"
							(click)="isPlatformUsersMode() ? onPlatformPageChange(platformPage + 1) : onMyUsersPageChange(myUsersPage + 1)">
							<i class="fa fa-chevron-right"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>

<ng-template #content let-modal>
	<div class="modal-header d-flex justify-content-between">
		<h6 class="modal-title" style="color: grey;">
			{{ 'users.addUser.title' | translate }}
		</h6>
		<button type="button" class="close btn-close" style="color: grey;" aria-label="Close"
			(click)="modal.dismiss('Cross click')">
		</button>
	</div>
	<div class="modal-body">
		<div class="container-fluid">
			<div class="edit-profile">
				<div class="row d-flex justify-content-between">
					<form [formGroup]="addUser" novalidate [ngClass]="{ 'was-validated': validate }">
						<div class="row">
							<div class="mb-3 col-xl-6 col-md-6">
								<label class="form-label" style="color: grey;">
									{{ 'users.addUser.userName' | translate }}
								</label>
								<input style="color: grey;" required="" onlyAlphabets class="form-control"
									maxlength="20" type="text" formControlName="user_name" />
								<div class="invalid-feedback text-danger" *ngIf="addUser.get('user_name')?.hasError('maxlength')">{{ 'users.addUser.userNameMaxLength' | translate }}</div>
								<div class="invalid-feedback text-danger" *ngIf="!addUser.get('user_name')?.hasError('maxlength')">{{ 'users.addUser.userNameError' | translate }}</div>
							</div>
							<div class="mb-3 col-xl-6 col-md-6">
								<label class="col-form-label pt-0" style="color: #141414;">
									{{ 'users.addUser.phoneNumber' | translate }}
								</label>
								<div class="input-group">
									<span style="color: #141414;" class="input-group-text">+972</span>
									<input class="form-control" type="text" maxlength="10" required="" onlyAlphabets
										placeholder="{{ 'users.addUser.phoneNumberPlaceholder' | translate }}"
										formControlName="phone_number">
								</div>
								<div *ngIf="addUser.get('phone_number')?.errors != null && addUser.get('phone_number')?.touched"
									class="alert text-danger my-1">
									<p *ngIf="addUser.get('phone_number')?.errors?.required" class="my-1 text-danger">{{ 'users.addUser.phoneNumberRequired' | translate }}</p>
									<p *ngIf="addUser.get('phone_number')?.errors?.invalidMobilePrefix" class="my-1 text-danger">{{ addUser.get('phone_number')?.errors?.invalidMobilePrefix.message }}</p>
									<p *ngIf="addUser.get('phone_number')?.errors?.invalidPhoneNumber" class="my-1 text-danger">{{ addUser.get('phone_number')?.errors?.invalidPhoneNumber.message }}</p>
								</div>
								<div class="invalid-feedback text-danger">{{ 'users.addUser.phoneNumberError' | translate }}</div>
							</div>
							<div class="mb-3 col-xl-6 col-md-6">
								<label class="form-label" style="color: grey;">
									{{ 'users.addUser.userType' | translate }}
								</label>
								<select class="js-example-basic-single col-xl-12 job-select2 form-select-sm" required=""
									onlyAlphabets style="border: solid 1px grey;" (change)="filter($event)"
									formControlName="user_type">
									<option [value]="200">{{ 'users.types.admin' | translate }}</option>
									<option [value]="201">{{ 'users.types.adminAssistant' | translate }}</option>
								</select>
								<div class="invalid-feedback text-danger">{{ 'users.addUser.userTypeError' | translate }}</div>
							</div>
							<div class="mb-3 col-xl-6 col-md-6">
								<div class="form-group position-relative">
									<label class="form-label" style="color: grey;">{{ 'users.addUser.password' | translate }}</label>
									<input class="form-control" [type]="show ? 'text' : 'password'"
										name="login[password]" formControlName="password" required=""
										placeholder="*********" (input)="handlePasswordValidation(addUser)">
									<div *ngIf="addUser.get('password')?.errors && addUser.get('password')?.touched"
										class="alert text-danger my-1">
										<p *ngIf="addUser.get('password')?.errors?.required" class="my-1 text-danger">{{ 'users.addUser.passwordRequired' | translate }}</p>
										<p *ngIf="addUser.get('password')?.errors?.minlength" class="my-1 text-danger">{{ 'users.addUser.passwordMinLength' | translate }}</p>
										<p *ngIf="addUser.get('password')?.errors?.maxlength" class="my-1 text-danger">{{ 'users.addUser.passwordMaxLength' | translate }}</p>
										<p *ngIf="addUser.get('password')?.errors?.uppercase" class="my-1 text-danger">{{ 'users.addUser.passwordUppercase' | translate }}</p>
										<p *ngIf="addUser.get('password')?.errors?.specialChar" class="my-1 text-danger">{{ 'users.addUser.passwordSpecialChar' | translate }}</p>
									</div>
									<div class="show-hide" [ngClass]="{'rtl': curentLang === 'ar' || curentLang === 'he'}" (click)="showPassword()">
										<i class="fa" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"></i>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-sm m-auto mt-2" style="background-color: #141414; color: #fff;"
								[disabled]="addUser.get('password').invalid" (click)="addedData()">
								{{ 'users.addUser.confirm' | translate }}
								<i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
							</button>
							<button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
								{{ 'users.addUser.back' | translate }}
								<i class="fa fa-rotate-left mx-1"></i>
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #content2 let-modal>
	<div class="modal-header d-flex justify-content-between">
		<h6 class="modal-title" style="color: grey;">
			{{ 'users.addUser.title' | translate }}
		</h6>
		<button type="button" class="close btn-close" style="color: grey;" aria-label="Close"
			(click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<div class="container-fluid">
			<div class="edit-profile">
				<div class="row d-flex justify-content-between">
					<form [formGroup]="merchantUser" novalidate [ngClass]="{ 'was-validated': validate }">
						<div class="row">
							<div class="mb-3 col-xl-12 col-md-12">
								<label class="form-label" style="color: grey;">
									{{ 'users.addUser.userName' | translate }}
								</label>
								<input style="color: grey;" required="" onlyAlphabets class="form-control"
									maxlength="20" type="text" formControlName="user_name" />
								<div class="invalid-feedback text-danger" *ngIf="merchantUser.get('user_name')?.hasError('maxlength')">{{ 'users.addUser.userNameMaxLength' | translate }}</div>
								<div class="invalid-feedback text-danger" *ngIf="!merchantUser.get('user_name')?.hasError('maxlength')">{{ 'users.addUser.userNameError' | translate }}</div>
							</div>
							<div class="mb-3 col-xl-12 col-md-12">
								<label class="col-form-label pt-0" style="color: #141414;">{{ 'users.addUser.phoneNumber' | translate }}</label>
								<div class="input-group">
									<span style="color: #141414;" class="input-group-text">+972</span>
									<input class="form-control" type="text" maxlength="10" required="" onlyAlphabets
										placeholder="{{ 'users.addUser.phoneNumberPlaceholder' | translate }}"
										formControlName="phone_number">
								</div>
								<div *ngIf="merchantUser.get('phone_number')?.errors != null && merchantUser.get('phone_number')?.touched"
									class="alert text-danger my-1">
									<p *ngIf="merchantUser.get('phone_number')?.errors?.required" class="my-1 text-danger">{{ 'users.addUser.phoneNumberRequired' | translate }}</p>
									<p *ngIf="merchantUser.get('phone_number')?.errors?.invalidMobilePrefix" class="my-1 text-danger">{{ merchantUser.get('phone_number')?.errors?.invalidMobilePrefix.message }}</p>
									<p *ngIf="merchantUser.get('phone_number')?.errors?.invalidPhoneNumber" class="my-1 text-danger">{{ merchantUser.get('phone_number')?.errors?.invalidPhoneNumber.message }}</p>
								</div>
								<div class="invalid-feedback text-danger">{{ 'users.addUser.phoneNumberError' | translate }}</div>
							</div>
							<div class="mb-3 col-xl-12 col-md-12">
								<div class="form-group position-relative">
									<label class="form-label" style="color: grey;">{{ 'users.addUser.password' | translate }}</label>
									<input class="form-control" [type]="show ? 'text' : 'password'"
										name="login[password]" formControlName="password" required=""
										placeholder="*********" (input)="handlePasswordValidation(merchantUser)">
									<div *ngIf="merchantUser.get('password')?.errors != null && merchantUser.get('password')?.touched"
										class="alert text-danger my-1">
										<p *ngIf="merchantUser.get('password')?.errors?.required" class="">{{ 'users.addUser.passwordRequired' | translate }}</p>
										<p *ngIf="merchantUser.get('password')?.errors?.minlength" class="my-1 text-danger">{{ 'users.addUser.passwordMinLength' | translate }}</p>
										<p *ngIf="merchantUser.get('password')?.errors?.maxlength" class="my-1 text-danger">{{ 'users.addUser.passwordMaxLength' | translate }}</p>
										<p *ngIf="merchantUser.get('password')?.errors?.uppercase" class="my-1 text-danger">{{ 'users.addUser.passwordUppercase' | translate }}</p>
										<p *ngIf="merchantUser.get('password')?.errors?.specialChar" class="my-1 text-danger">{{ 'users.addUser.passwordSpecialChar' | translate }}</p>
									</div>
									<div class="show-hide" [ngClass]="{'rtl': curentLang === 'ar' || curentLang === 'he'}" (click)="showPassword()">
										<i class="fa" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"></i>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-sm m-auto mt-2" style="background-color: #141414; color: #fff;"
								[disabled]="merchantUser.get('password').invalid" (click)="addMerchantUser()">
								{{ 'users.addUser.confirm' | translate }}
								<i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
							</button>
							<button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
								{{ 'users.addUser.back' | translate }}
								<i class="fa fa-rotate-left mx-1"></i>
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-container *ngIf="isInsideModal">
	<div class="container-fluid">
		<div class="users-card">
			<div class="users-card-header">
				<div class="users-header-top">
					<h5 class="users-title">
						<i class="fa fa-users users-title-icon"></i>
						{{ 'menu.users' | translate }}
					</h5>
					<div class="users-header-actions">
						<button class="users-btn users-btn-add" (click)="openXl(content)" *ngIf="user_type == 200">
							<i class="fa fa-plus"></i>
							<span class="users-btn-label">{{ 'users.info.addUser' | translate }}</span>
						</button>
						<button class="users-btn users-btn-add" (click)="openXl2(content2)" *ngIf="user_type == 100">
							<i class="fa fa-plus"></i>
							<span class="users-btn-label">{{ 'users.info.addUser' | translate }}</span>
						</button>
						<button class="users-btn users-btn-refresh" (click)="refreshUsersData()">
							<i class="fa fa-refresh"></i>
						</button>
					</div>
				</div>

				<div class="users-toolbar">
					<div class="users-scope-toggle" *ngIf="canUsePlatformUsers">
						<button class="scope-btn" [class.active]="userScope === 'all'"
							(click)="userScope = 'all'; onUserScopeChange()">
							<i class="fa fa-users"></i>
							{{ curentLang === 'ar' ? 'المستخدمين' : (curentLang === 'he' ? 'משתמשים' : 'My Users') }}
						</button>
						<button class="scope-btn" [class.active]="userScope === 'admin'"
							(click)="userScope = 'admin'; onUserScopeChange()">
							<i class="fa fa-globe"></i>
							{{ curentLang === 'ar' ? 'كل المنصة' : (curentLang === 'he' ? 'כל הפלטפורמה' : 'All Platform') }}
						</button>
					</div>

					<div class="users-search">
						<i class="fa fa-search users-search-icon"></i>
						<input type="text" name="search" [ngModelOptions]="{standalone: true}"
							[(ngModel)]="term" placeholder="{{ 'users.info.search' | translate }}"
							class="users-search-input" />
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-sm-12">
					<div class="card" id="headingTwo"
						*ngFor="let item of userData | paginate: {itemsPerPage:50, currentPage:p} | filter:term; let i = index">
						<p (click)="toggleCollapse(i)" [attr.aria-expanded]="openedIndex === i" aria-controls="collapse"
							style="cursor: pointer; background-color: #FB4438;" class="py-1">
							<i class="fa fa-user-circle mx-1" style="color: #fff; font-size: 16px;"></i>
							<span style="color: #fff; font-size: 16px;" class="mx-2">{{ item?.user_name }}</span>
						</p>
						<div class="row d-flex justify-content-between">
							<div class="col-md-12 col-sm-12">
								<div class="row collapse show" id="collapseTwo" [ngbCollapse]="openedIndex !== i">
									<div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between">
										<span style="color: #141414; font-size: 14px;" class="col-sm-4 mx-2">
											{{ 'users.table.phoneNumber' | translate }}
										</span>
										<span style="color: #141414; font-size: 14px;" class="text-center col-sm-4">{{
											formatPhoneNumber(item?.phone_number) }}</span>
										<span class="col-sm-4 text-end">
											<i class="fa fa-phone-square px-5" style="color: #141414; font-size: 16px;"></i>
										</span>
									</div>
									<hr style="border: solid 1px #141414;">
									<div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between">
										<span style="color: #141414; font-size: 14px;" class="col-sm-4 mx-2">
											{{ 'users.table.userType' | translate }}
										</span>
										<span class="text-danger text-center col-sm-4" style="font-weight: 600;">
											{{ getUserTypeLabel(item) }}
										</span>
										<span class="col-sm-4 text-end">
											<i class="fa fa-user px-5" style="color: #141414; font-size: 16px;"></i>
										</span>
									</div>
									<hr style="border: solid 1px #141414;">
									<div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between">
										<span style="color: #141414; font-size: 14px;" class="col-sm-4 mx-2">
											{{ 'users.table.verified' | translate }}
										</span>
										<div class="text-center col-sm-4"></div>
										<span style="color: #141414;" class="text-end col-sm-4" *ngIf="item?.mverified == 1">
											<i class="fa fa-check-circle px-5" style="font-size: 16px; color: green;"></i>
										</span>
										<span class="col-sm-4 text-end" *ngIf="item?.mverified == 0">
											<i class="fa fa-close px-5" style="font-size: 16px; color: red;"></i>
										</span>
									</div>
									<hr style="border: solid 1px #141414;">
									<div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between">
										<span style="color: #141414; font-size: 14px;" class="col-sm-4 mx-2">
											{{ 'users.table.status' | translate }}
										</span>
										<div class="text-center col-sm-4"></div>
										<span style="color: #141414;" class="text-end col-sm-4" *ngIf="item?.mverified == 1">
											<span class="col-sm-4 text-end">
												<button [disabled]="item.user_type === 200 || item.user_type === 100"
													*ngIf="item.user_status == 1" class="btn px-5" style="border: none;"
													(click)="changeUserStatus(item?.user_id, item.user_status)">
													<i class="fa solid fa-solid fa-toggle-on" style="color: #213FA6;"></i>
												</button>
												<button *ngIf="item.user_status == 59" class="btn px-5" style="border: none;"
													(click)="changeUserStatus(item?.user_id, item.user_status)">
													<i class="fa solid fa-solid fa-toggle-off" style="color: red;"></i>
												</button>
											</span>
										</span>
									</div>
									<hr style="border: solid 1px #141414;">
									<div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between">
										<span style="color: #141414; font-size: 14px;" class="col-sm-4 mx-2">
											{{ 'users.table.createdDate' | translate }}
										</span>
										<span style="color: #141414; font-size: 14px;" class="text-center col-sm-4">
											{{ item.createdDate | date: 'dd/MM/yyyy' }}
										</span>
										<span style="color: #141414;" class="text-end col-sm-4">
											<i class="fa fa-history px-5" style="font-size: 16px; color: #141414;"></i>
										</span>
									</div>
									<hr style="border: solid 1px #141414;">
									<div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between">
										<span style="color: #141414; font-size: 14px;" class="col-sm-4 mx-2">
											{{ 'users.table.createdBy' | translate }}
										</span>
										<span style="color: #141414; font-size: 14px;" class="text-center col-sm-4 creator-label"
											[class.creator-label--fallback]="isCreatedByFallback(item)">
											{{ getCreatedByLabel(item) }}
										</span>
										<span style="color: #141414;" class="text-end col-sm-4">
											<i class="fa fa-user px-5" style="font-size: 16px; color: #141414;"></i>
										</span>
									</div>
									<hr style="border: solid 1px #141414;">
									<div *ngIf="!isPlatformUsersMode()" class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between">
										<span style="color: #141414; font-size: 14px;" class="col-sm-4 mx-2">
											{{ 'users.table.privileges' | translate }}
										</span>
										<div class="text-center col-sm-4"></div>
										<span style="color: #141414;" class="text-end col-sm-4">
											<i *ngIf="canShowPrivileges(item)"
												routerLink="/dashboard/user-privileges/{{item?.user_id}}"
												class="fa fa-file-archive-o px-5"
												style="font-size: 16px; cursor: pointer;"></i>
											<i *ngIf="canShowLockIcon(item)"
												class="fa fa-lock px-5"
												style="cursor: pointer; font-size: 16px; color: grey;"></i>
										</span>
									</div>
									<hr *ngIf="!isPlatformUsersMode()" style="border: solid 1px #141414;">

									<div *ngIf="canUseSecurityCode" class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between align-items-center py-2">
										<span style="color: #141414; font-size: 14px;" class="col-sm-4 mx-2">
											{{ curentLang === 'ar' ? 'كود الأمان' : (curentLang === 'he' ? 'קוד אבטחה' : 'Security Code') }}
										</span>
										<div class="text-center col-sm-4"></div>
										<span class="text-end col-sm-4 d-flex justify-content-end gap-2 px-4">
											<button class="sc-action-btn sc-view" (click)="viewSecurityCode(item.user_id)"><i class="fa fa-eye"></i></button>
											<button class="sc-action-btn sc-send" (click)="sendSecurityCodeSms(item.user_id)"><i class="fa fa-paper-plane"></i></button>
											<button class="sc-action-btn sc-change" (click)="rotateSecurityCode(item.user_id)"><i class="fa fa-refresh"></i></button>
										</span>
									</div>
									<hr *ngIf="canUseSecurityCode" style="border: solid 1px #141414;">
								</div>
							</div>
						</div>
						<hr style="color: #141414; border: solid 1px;">
					</div>
					<pagination-controls (pageChange)="p = $event" class="m-auto my-3 current"></pagination-controls>
				</div>
			</div>
		</div>
	</div>
</ng-container>
